import { notification } from "antd";
import cuid from "cuid";
import { defaults, get, map } from "lodash";
import { useState } from "react";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { GENERATE_SUBSCRIPTION_DOCUMENTS } from "utils/api/graphql/mutations/attachment";
import { SUBSCRIPTION_STEPS } from "../..";
import GeneratingDocuments from "./GeneratingDocuments";
import View from "./View";

const Subscription = ({
  subscription,
  onNext,
  generalCost,
  initialValues,
  updateSubscription,
  totalPrice,
  setCurrentStep,
  currentStep,
}) => {
  const [loading, setLoading] = useState(false);
  const [generatingDocuments, setGeneratingDocuments] = useState(false);
  const [generateSubscriptionDocuments] = useMutation(
    GENERATE_SUBSCRIPTION_DOCUMENTS,
    {
      refetchQueries: [
        {
          query: graphql.queries.SUBSCRIPTION,
          awaitRefetchQueries: true,
          variables: { where: { id: get(subscription, "id") } },
        },
      ],
    },
  );

  const onSubmit = async (values) => {
    setLoading(true);
    const { consent, contactTelecoms, ...data } = values;
    const telecoms = map(contactTelecoms, (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    updateSubscription({
      variables: {
        where: { id: get(subscription, "id") },
        data: {
          project: {
            ...get(subscription, "project"),
            fields: {
              ...get(subscription, "project.fields"),
              consent: {
                ...get(subscription, "project.fields.consent"),
                ...consent,
              },
            },
            contact: {
              ...get(subscription, "project.contact"),
              telecoms,
            },
          },
          payment: {
            ...get(subscription, "payment"),
            ...get(data, "payment"),
            payer: {
              ...get(subscription, "payment.payer"),
              ...get(data, "payment.payer"),
              owner: {
                ...get(subscription, "payment.payer.owner"),
                ...get(data, "payment.payer.owner"),
              },
            },
          },
        },
      },
      onCompleted: async () => {
        if (get(subscription, "locked")) {
          setCurrentStep(SUBSCRIPTION_STEPS.VIEW_DOCUMENTS);
          setLoading(false);
        } else {
          setGeneratingDocuments(true);
          generateSubscriptionDocuments({
            variables: {
              data: { id: get(subscription, "id") },
            },
            onCompleted: ({ generateSubscriptionDocuments: { base64 } }) => {
              setGeneratingDocuments(false);
              setCurrentStep(SUBSCRIPTION_STEPS.VIEW_DOCUMENTS);
              setLoading(false);
              notification.open({
                message:
                  "Les données ne peuvent plus être modifiées, mais l’envoi d’une demande de signature électronique au client reste possible ",
                duration: 5,
                type: "info",
              });
            },
            onError: () => {
              setGeneratingDocuments(false);
              setLoading(false);
            },
          });
        }
      },
    });
  };

  return (
    <>
      {generatingDocuments ? (
        <GeneratingDocuments />
      ) : (
        <View
          onSubmit={onSubmit}
          onBack={() => {}}
          loading={loading}
          setLoading={setLoading}
          subscription={subscription}
          generalCost={generalCost}
          initialValues={initialValues}
          totalPrice={totalPrice}
        />
      )}
    </>
  );
};

export default Subscription;
